import React from 'react';
import ButtonUI from './ButtonUI';
import {
    Check as CheckIcon
} from '@material-ui/icons';
import {
    DialogTitle, Dialog, DialogActions,
    DialogContent, DialogContentText
} from '@material-ui/core';
import useKeypress from '../../utils/useKeypress'

interface props {
    mensage: string,
    isOpen: boolean;
    onClose: () => any;
    onCloseConfirmModal: (any: boolean) => void
}

export default function ConfirmModalUI(props: props) {

    useKeypress('Escape', () => {
        if (props.isOpen === true)
            props.onClose();
    }, props.isOpen);

    const handleConfirm = (confirm: boolean) => {
        props.onCloseConfirmModal(confirm);
    };

    return (
        <div>
            <Dialog
                open={props.isOpen}
                // onClose={() => handleConfirm(false)}
                onBackdropClick={() => props.onClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description" >
                <DialogTitle>
                    Atenção
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.mensage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonUI
                        variant="outlined"
                        onClick={props.onClose}
                    >
                        Cancelar
                    </ButtonUI>

                    <ButtonUI
                        variant="contained"
                        color="primary"
                        type="submit"
                        startIcon={<CheckIcon />}
                        onClick={() => handleConfirm(true)}
                    >
                        Confirmar
                    </ButtonUI>                    
                </DialogActions>
            </Dialog>
        </div>
    );
}